import { useNavigate, useLocation } from "react-router-dom";

/**
 * Hook personnalisé pour une navigation intelligente
 * Gère le retour en arrière de manière intelligente avec une page de fallback
 */
export const useSmartNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Retourne à la page précédente ou à une page de fallback
   * @param fallbackPath - Chemin vers lequel rediriger si pas d'historique
   */
  const goBack = (fallbackPath: string = "/") => {
    // Vérifier si on a un état de navigation avec une page d'origine
    const from = location.state?.from;
    
    if (from) {
      // Si on a une page d'origine dans le state, on y retourne
      navigate(from);
    } else if (window.history.length > 2) {
      // Si on a un historique, on retourne en arrière
      navigate(-1);
    } else {
      // Sinon, on va à la page de fallback
      navigate(fallbackPath);
    }
  };

  /**
   * Navigue vers une page en enregistrant l'origine
   * @param path - Chemin de destination
   * @param options - Options supplémentaires
   */
  const navigateWithOrigin = (path: string, options?: { replace?: boolean }) => {
    navigate(path, {
      state: { from: location.pathname },
      replace: options?.replace,
    });
  };

  return {
    navigate,
    goBack,
    navigateWithOrigin,
  };
};

